<script setup lang="ts">
  import { cva } from 'class-variance-authority'
  import type { IInfoCtaProps } from '@/components/ui/info/cta.types'
  import { pushValidatedDataLayer } from '@/utils/dataLayer'

  const props = withDefaults(defineProps<IInfoCtaProps>(), {
    variant: 'primary',
    cta: null,
    ctaTitle: '',
    dataLayer: null
  })

  const base = computed(() =>
    cva('px-6 py-8 flex justify-center rounded-md', {
      variants: {
        variant: {
          primary: 'bg-light-info'
        }
      }
    })({
      variant: props.variant
    })
  )

  const redirect = (url: string) => {
    if (!url) {
      return
    }

    if (props.dataLayer) {
      pushValidatedDataLayer(props.dataLayer)
    }

    navigateTo(url, { external: true })
  }
</script>

<template>
  <div :class="base">
    <div class="flex max-w-68 flex-col justify-center gap-2 text-center md:max-w-100">
      <p
        v-if="title.length"
        class="m-0 text-h5"
      >
        {{ title }}
      </p>
      <p
        v-if="$slots.content?.length"
        class="m-0 text-body-2"
      >
        <slot name="content" />
      </p>
      <div v-if="cta">
        <UiButton
          :title="ctaTitle"
          variant="secondary"
          size="lg"
          class="w-full md:w-auto"
          data-test="cta"
          @click="redirect(cta?.content?.href?.url)"
        />
      </div>
    </div>
  </div>
</template>
